var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { getEnv } from "@ledgerhq/live-env";
import { delay } from "@ledgerhq/live-promise";
import { isNFTActive } from "@ledgerhq/coin-framework/nft/support";
import { isLedgerExplorerConfig } from "./types";
import { LedgerExplorerUsedIncorrectly } from "../../errors";
import { ledgerERC20EventToOperations, ledgerERC721EventToOperations, ledgerERC1155EventToOperations, ledgerOperationToOperations, } from "../../adapters/index";
export const BATCH_SIZE = 10000;
export const LEDGER_TIMEOUT = 200; // 200ms between 2 calls
export const DEFAULT_RETRIES_API = 2;
/**
 * Request fetching all operations from an address
 * and supporting pagination through tokens.
 */
export function fetchPaginatedOpsWithRetries(params, paginationToken = null, previousOperations = [], retries = DEFAULT_RETRIES_API) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { data: { data: operationsBatch, token }, } = yield axios.request({
                headers: { "X-Ledger-Client-Version": getEnv("LEDGER_CLIENT_VERSION") },
                method: "GET",
                url: `${getEnv("EXPLORER")}/blockchain/v4/${params.explorerId}/address/${params.address}/txs`,
                params: {
                    filtering: true,
                    from_height: (_a = params.fromBlock) !== null && _a !== void 0 ? _a : 0,
                    order: "ascending",
                    batch_size: BATCH_SIZE,
                    token: paginationToken,
                },
            });
            const mergedOperations = [...previousOperations, ...operationsBatch];
            return token
                ? fetchPaginatedOpsWithRetries(params, token, mergedOperations, retries)
                : mergedOperations.sort(
                // sorting DESC order
                (a, b) => new Date(b.block.time).getTime() - new Date(a.block.time).getTime());
        }
        catch (e) {
            if (retries) {
                // wait the API timeout before trying again
                yield delay(LEDGER_TIMEOUT);
                // decrement with prefix here or it won't work
                return fetchPaginatedOpsWithRetries(params, paginationToken, previousOperations, --retries);
            }
            throw e;
        }
    });
}
/**
 * Returns all operation types from an address
 */
export const getLastOperations = (currency, address, accountId, fromBlock) => __awaiter(void 0, void 0, void 0, function* () {
    const { explorer } = currency.ethereumLikeInfo || /* istanbul ignore next */ {};
    if (!isLedgerExplorerConfig(explorer)) {
        throw new LedgerExplorerUsedIncorrectly(`Ledger explorer used incorrectly with currency: ${currency.id}`);
    }
    const ledgerExplorerOps = yield fetchPaginatedOpsWithRetries({
        explorerId: explorer.explorerId,
        address,
        fromBlock,
    });
    const lastCoinOperations = [];
    const lastTokenOperations = [];
    const lastNftOperations = [];
    ledgerExplorerOps.forEach(ledgerOp => {
        const coinOps = ledgerOperationToOperations(accountId, ledgerOp);
        const erc20Ops = ledgerOp.transfer_events.flatMap(event => ledgerERC20EventToOperations(coinOps[0], event));
        const erc721Ops = isNFTActive(currency)
            ? ledgerOp.erc721_transfer_events.flatMap((event, index) => ledgerERC721EventToOperations(coinOps[0], event, index))
            : [];
        const erc1155Ops = isNFTActive(currency)
            ? ledgerOp.erc1155_transfer_events.flatMap((event, index) => ledgerERC1155EventToOperations(coinOps[0], event, index))
            : [];
        lastCoinOperations.push(...coinOps);
        lastTokenOperations.push(...erc20Ops);
        lastNftOperations.push(...erc721Ops);
        lastNftOperations.push(...erc1155Ops);
    });
    return {
        lastCoinOperations,
        lastTokenOperations,
        lastNftOperations,
    };
});
export default {
    getLastOperations,
};
//# sourceMappingURL=ledger.js.map